import React from 'react';
import PropTypes from 'prop-types';
import { Table, Button, Popconfirm, Popover, Tag } from 'antd';
import './styles.css';

const { Column } = Table;

const RestaurantsTable = ({ data, onActiveRestaurant }) => {
    return (
        <Table className="restaurantsTableCont" dataSource={data} rowKey="id" size="middle" pagination={false}>
            <Column className="nameCont" title="Nombre" dataIndex="name" key="name" align="center" 
            render={(text, record) => {
                    return (
                    <span>
                        <Popover content={
                            <div>
                                {record.id}
                            </div>
                        }>
                            {record.name}
                        </Popover>
                    </span>);
                }}/>
            <Column title="Estado" dataIndex="active" key="active" align="center"
                render={active => (
                    <span>
                        {
                            active ?
                                <Tag color='blue' key={active}>
                                    ACTIVADO
                                </Tag>
                                :
                                <Tag color='red' key={active}>
                                    DESACTIVADO
                                </Tag>
                        }
                    </span>
                )}
            />
            <Column title="" dataIndex="action" key="action" align="center"
                render={(text, record) => (
                    <span>
                        {
                            record.isLoading ?
                                <Button type="primary" disabled={true} loading>
                                    Cargando
                                </Button>
                                :
                                record.active ?
                                    <Popconfirm title="¿Desea descativar el restaurante?" okText="SI" cancelText="NO" onConfirm={() => onActiveRestaurant(record)}>
                                        <Button type="danger">Desactivar</Button>
                                    </Popconfirm>
                                    :
                                    <Popconfirm title="¿Desea activar el restaurante?" okText="SI" cancelText="NO" onConfirm={() => onActiveRestaurant(record)}>
                                        <Button type="primary">Activar</Button>
                                    </Popconfirm>
                        }
                    </span>
                )}
            />
        </Table>
    );
};

RestaurantsTable.propTypes = {
    data: PropTypes.array,
    onActiveRestaurant: PropTypes.func,
};

export default RestaurantsTable;